import { z } from 'zod';

export interface APIResponse<T> {
  data: T;
}
export interface GroupType {
  PartitionKey: string;
  RowKey: string;
  id: string;
  fn: string;
  type: string;
  participants: string[];
}

export interface TagMemberType {
  PartitionKey: string;
  RowKey: string;
  enabled: boolean;
  fn: string;
}

export interface TagType {
  name: string;
  members: TagMemberType[];
}

export const sentMessageResultSchema = z.object({
  sent: z.boolean(),
  message: z.object({
    chat_id: z.string(),
    device_id: z.number(),
    from_me: z.boolean(),
    id: z.string(),
    source: z.string(),
    status: z.string(),
    text: z.object({
      body: z.string(),
    }),
    timeStamp: z.string(),
    type: z.string(),
  }),
});

const ImageType =
  z.object({
    file_size: z.number(),
    height: z.number(),
    id: z.string(),
    mime_type: z.string(),
    preview: z.string(),
    sha256: z.string(),
    width: z.number(),
  }) || z.any();

export const sentImageResultSchema = z.object({
  sent: z.boolean(),
  message: z.object({
    chat_id: z.string(),
    device_id: z.number(),
    from: z.string(),
    from_me: z.boolean(),
    id: z.string(),
    image: ImageType,
    source: z.string(),
    status: z.string(),
    timeStamp: z.string(),
    type: z.string(),
  }),
});

// sentMessageResult type guard
export const isSentMessageResult = (arg: unknown) => {
  const validatedMessage = sentMessageResultSchema.safeParse(arg);
  if (validatedMessage.success) return validatedMessage.data;
};

// sentImageResult type guard
export const isSentImageResult = (arg: unknown) => {
  const validatedMessage = sentImageResultSchema.safeParse(arg);
  console.log(validatedMessage);
  if (validatedMessage.success) return validatedMessage.data;
};

export type MessageOutput = string;

export interface OutputLogInterface {
  ts: string;
  content?: z.infer<typeof sentMessageResultSchema>;
  image?: z.infer<typeof sentImageResultSchema>;
  message?: string;
}
